(() => {

    const MODULE = {

        Country: "CA",
        inputName: "Delivery Date",

        init: function () {
            this.registerEventHandlers();
        },

        getUser: function () {
            return {
                customerCountry: Shopify.country,
                currentPage: window.GSSDK.page.get(),
            };
        },

        registerEventHandlers: function () {
            document.addEventListener('giftship.loaded', this.handleGiftshipLoaded.bind(this));
            document.addEventListener('giftship.shipping.ready', this.handleShippingLoaded.bind(this));
            document.addEventListener('giftship.drawer-cart.opened', this.handleDrawerOpened.bind(this));
        },

        handleGiftshipLoaded: function () {
            const { customerCountry, currentPage } = this.getUser();

            if (customerCountry === this.Country) {
                if (currentPage === "product") {
                    this.removeDivs(`[data-child-name="${this.inputName}"]`, '#gsAppContainer');
                } else if (currentPage === "cart") {
                    this.removeDivs(`[data-child-name="${this.inputName}"]`, '#gsAppContainer');
                }
            }
        },

        handleShippingLoaded: function () {
            const { customerCountry, currentPage } = this.getUser();

            if (customerCountry === this.Country && currentPage === "multi-shipping") {
                this.removeDivs(`[data-child-name="${this.inputName}"]`, '#gsMultishippingPage');
            }
        },

        handleDrawerOpened: function () {
            const { customerCountry } = this.getUser();

            if (customerCountry === this.Country) {
                this.removeDivs(`[data-child-name="${this.inputName}"]`, '#gsDrawer');
            }
        },

        removeDivs: function (selector, containerId) {
            const container = document.querySelector(containerId);

            if (!container) return;

            const divs = container.querySelectorAll(selector);

            if (divs.length === 0) {
                const observer = new MutationObserver((mutations, obs) => {
                    const newDivs = container.querySelectorAll(selector);
                    if (newDivs.length > 0) {
                        newDivs.forEach(div => div.remove());
                        obs.disconnect();
                    }
                });

                observer.observe(container, { childList: true, subtree: true });
            } else {
                divs.forEach(div => div.remove());
            }
        },
    };

    MODULE.init();

})();